<template>
  <el-container>
    <el-header>
      <!-- <h1>AI 客服系统</h1> -->
      <h1>Home</h1>
    </el-header>
    <el-main>
      <router-view></router-view>
      <AIChatWidget />
    </el-main>
  </el-container>
</template>

<script>
import { RouterView } from 'vue-router'
import AIChatWidget from './components/AIChatWidget.vue'

export default {
  name: 'App',
  components: {
    RouterView, AIChatWidget
  }
}
</script>

<style scoped>
.el-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.el-header {
  background: linear-gradient(135deg, #409EFF 0%, #1e90ff 100%);
  color: white;
  line-height: 60px;
  text-align: center;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.el-main {
  padding: 40px;
  max-width: 1200px;
  margin: 0 auto;
}

/* Smooth transitions */
* {
  transition: all 0.3s ease;
}
</style>
